import axios from 'axios'
import moment from 'moment'
// import { notificationSuccess, notificationDanger } from '../../../utils/customToastify';

import { EDIT_REFERRAL_DATA, SET_DATA_FOR_REFERRAL_TABLE, CLEAN_UP_REFERRAL_DATA, SET_IS_REFERRAL_SENT } from './types'
import { closeModal } from '../../../../common/GlobalModal/redux/GlobalModalActions'
import { now } from '../../../../utils/utcTime'
import { notificationSuccess } from '../../../../utils/customToastify'

export const isContactReferred = (divisionId, contactId) => async (dispatch) => {
  const response = await axios.get('/referral/is-referred', { params: { divisionId, contactId } })
  dispatch({
    type: SET_IS_REFERRAL_SENT,
    payload: response.data,
  })
}

export const editReferralData = (name, value) => async (dispatch) => {
  dispatch({
    type: EDIT_REFERRAL_DATA,
    payload: { name, value },
  })
}

export const cleanUpReferralData = () => async (dispatch) => {
  dispatch({
    type: CLEAN_UP_REFERRAL_DATA,
  })
}

export const saveReferral = () => async (dispatch, getState) => {
  const state = getState()
  const data = state.Referral.data
  const userData = state.auth.user

  const response = await axios.post('/referral', {
    ...data,
    dueDate: moment(data.dueDate).utc().format('YYYY-MM-DD HH:mm:ss'),
    delayDate: moment(data.delayDate).utc().format('YYYY-MM-DD'),
    divisionFrom: userData.division_id,
    creationDate: now(),
  })

  if (response.status === 200) {
    notificationSuccess('Referral successfully sent!')
    dispatch(closeModal('referral'))
  }
}

export const getDataForReferralTable = (options) => async (dispatch) => {
  const reponse = await axios.get('/referral/get-referrals', { params: { ...options } })
  dispatch({
    type: SET_DATA_FOR_REFERRAL_TABLE,
    payload: reponse.data,
  })
}
